import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "https://api.viralstrateji.com";

export default function ItemsDemo() {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  async function loadItems() {
    setLoading(true);
    setMsg("");
    try {
      const res = await fetch(`${API_BASE}/items`);
      const data = await res.json();
      setItems(data.items || []);
    } catch (err) {
      setMsg("Liste yüklenemedi ❌");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { loadItems(); }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!title.trim()) {
      setMsg("Başlık gerekli ⚠️");
      return;
    }
    try {
      const res = await fetch(`${API_BASE}/items`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title, note }),
      });
      const data = await res.json();
      if (data.ok) {
        setTitle("");
        setNote("");
        setMsg("Kayıt eklendi ✅");
        loadItems();
      } else {
        setMsg("Ekleme başarısız ❌");
      }
    } catch {
      setMsg("Sunucu hatası ⚙️");
    }
  }

  return (
    <div style={{
      maxWidth: 500,
      margin: "40px auto",
      fontFamily: "system-ui, sans-serif",
      padding: 16
    }}>
      <h2>Items Demo</h2>

      <form onSubmit={handleSubmit} style={{ display: "grid", gap: 8, marginBottom: 16 }}>
        <input
          placeholder="Başlık"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ padding: 8, border: "1px solid #ddd", borderRadius: 8 }}
        />
        <textarea
          placeholder="Not (isteğe bağlı)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          style={{ padding: 8, border: "1px solid #ddd", borderRadius: 8 }}
        />
        <button
          type="submit"
          style={{
            padding: "10px 14px",
            borderRadius: 8,
            border: "1px solid #ccc",
            cursor: "pointer",
          }}
        >
          Ekle
        </button>
      </form>

      {msg && <p>{msg}</p>}
      {loading && <p>Yükleniyor...</p>}

      <ul style={{ listStyle: "none", padding: 0 }}>
        {items.map((it) => (
          <li key={it.id} style={{
            border: "1px solid #eee",
            borderRadius: 8,
            padding: 10,
            marginBottom: 8
          }}>
            <b>{it.title}</b>
            {it.note && <div style={{ color: "#666" }}>{it.note}</div>}
            <div style={{ fontSize: 12, color: "#999" }}>{it.createdAt}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
